module.exports = __webpack_public_path__ + "static/media/9.62c0e6c7.png";